'use client';

import { useTradeSettingsStore } from '@/stores/trade-settings';
export function useAllowRapidTrades() {
  return useTradeSettingsStore(_temp);
}
function _temp(state) {
  return state.allowRapidTrades;
}